import URLS from '../config/urls';
import BaseAPI from './BaseApi';


class AdministratorService {
    async getList(params: any): Promise<any> {
        try {
            const response = await BaseAPI.get(`${URLS.ACCOUNTS}/search`, { params });
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao trazer listagem" }; // Retorna um objeto de erro
        }
    }

    async getAdministratorByUuid(uuid: any): Promise<any> {
        try {
            const response = await BaseAPI.get(`${URLS.ACCOUNTS}/${uuid}?by=uuid`);
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao buscar dados" }; // Retorna um objeto de erro
        }
    }

    async createAdministrator(data: any): Promise<any> {
        try {
            const response = await BaseAPI.post(`${URLS.ACCOUNTS}`, data);
            return response; // Retorna a resposta da API
        } catch (e: any) {
            return { error: e.response.data.message ?? "Erro ao cadastrar" }; // Retorna um objeto de erro
        }
    }

    async editAdministrator(data: any, uuid: string | undefined): Promise<any> {
        try {
            const response = await BaseAPI.put(`${URLS.ACCOUNTS}/${uuid}`, data);
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao editar" }; // Retorna um objeto de erro
        }
    }

    async deleteAdministrator(uuid: string): Promise<any> {
        try {
            const response = await BaseAPI.delete(`${URLS.ACCOUNTS}/${uuid}`);
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao deletar" }; // Retorna um objeto de erro
        }
    }

    async getAccount(email: string | undefined): Promise<any> {
        try {
            const response = await BaseAPI.get(`${URLS.ACCOUNTS}/${email}`);
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao buscar dados" }; // Retorna um objeto de erro
        }
    }

    async getEligibleParent(hierarchy: string): Promise<any> {
        try {
            const response = await BaseAPI.get(`${URLS.ACCOUNTS}/eligible-parent-administrators/search?size=9999&page=0&sort=name&hierarchyGreaterThan=${hierarchy}`);
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao buscar dados" }; // Retorna um objeto de erro
        }
    }

    async getChildAdminstratorByTerm(term: string | undefined): Promise<any> {
        try {
            const response = await BaseAPI.get(`${URLS.ACCOUNTS}/eligible-child-administrators/search?size=9999&page=0&sort=name&username=${term}&hierarchyLessThan=3`);
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao buscar dados" }; // Retorna um objeto de erro
        }
    }


    async getChildAdminstrator(uuid: any, params: any): Promise<any> {
        try {
            const response = await BaseAPI.get(`${URLS.ACCOUNTS}/${uuid}/children`, { params });
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao trazer listagem" }; // Retorna um objeto de erro
        }
    }

    async addChildAdminstrator(uuid: any, payload: any): Promise<any> {
        try {
            const response = await BaseAPI.put(`${URLS.ACCOUNTS}/${uuid}/children/add`, payload);
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao trazer listagem" }; // Retorna um objeto de erro
        }
    }

    async removeChildAdminstrator(uuid: any, payload: any): Promise<any> {
        try {
            const response = await BaseAPI.put(`${URLS.ACCOUNTS}/${uuid}/children/remove`, payload);
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao trazer listagem" }; // Retorna um objeto de erro
        }
    }


    async getChildCustomerByTerm(document: string | undefined): Promise<any> {
        try {
            const response = await BaseAPI.get(`${URLS.CUSTOMERS}/search?size=999999&page=0&sort=created,asc&document=${document}`);
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao buscar dados" }; // Retorna um objeto de erro
        }
    }


    async getChildCustomer(uuid: any, params: any): Promise<any> {
        try {
            const response = await BaseAPI.get(`${URLS.ACCOUNTS}/${uuid}/customers`, { params });
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao trazer listagem" }; // Retorna um objeto de erro
        }
    }

    async addChildCustomer(uuid: any, payload: any): Promise<any> {
        try {
            const response = await BaseAPI.put(`${URLS.ACCOUNTS}/${uuid}/customers/add`, payload);
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao trazer listagem" }; // Retorna um objeto de erro
        }
    }

    async removeChildCustomer(uuid: any, payload: any): Promise<any> {
        try {
            const response = await BaseAPI.put(`${URLS.ACCOUNTS}/${uuid}/customers/remove`, payload);
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao trazer listagem" }; // Retorna um objeto de erro
        }
    }
}

const administratorService = new AdministratorService();
export default administratorService;